<template>
  <FreeModal :name="modalName">
    <template v-if="title" #header>
      <h3 class="text-text-neutral-primary text-center text-lg font-semibold">
        {{ title }}
      </h3>
    </template>
    <template #default="{ hide }">
      <div class="mt-1">
        <p
          v-if="message"
          class="text-text-neutral-tertiary text-center text-sm font-medium"
        >
          {{ message }}
        </p>
        <div class="mt-6 flex space-x-2">
          <FreeButton
            type="button"
            class="bg-situational-lightgrey grow"
            :class="
              isPositive
                ? 'text-text-negative-primary'
                : 'text-text-neutral-primary'
            "
            @click="hide"
          >
            {{ cancelLabel ?? t('confirmationModal.no') }}
          </FreeButton>
          <FreeButton
            type="button"
            class="bg-situational-lightgrey grow"
            :class="
              isPositive
                ? 'text-text-neutral-secondary'
                : 'text-text-negative-primary'
            "
            @click="onAgree(hide)"
          >
            {{ confirmLabel ?? t('confirmationModal.yes') }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeModal>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';

  import messages from '../config/locales.json';
  import { FreeButton, FreeModal } from '../../../shared/ui';

  const props = defineProps<{
    modalName: string;
  }>();

  const emit = defineEmits<{
    onAgree: [];
  }>();

  const { t } = useI18n({ messages });

  const modal = controllerModel.useModal();

  const params = computed(() => modal.getParams(props.modalName) || {});
  const title = computed(() => params.value.title);
  const message = computed(() => params.value.message);
  const isPositive = computed(() => params.value.isPositive);
  const cancelLabel = computed(
    () => params.value.cancelLabel as string | undefined,
  );
  const confirmLabel = computed(
    () => params.value.confirmLabel as string | undefined,
  );

  const onAgree = (hide: () => void) => {
    emit('onAgree');
    hide();
  };
</script>
